export const ALREADY_SUBMITTED_MESSAGE = "この見積は既に依頼済みです。見積詳細画面を表示します。";

function isSubmittedDetailRedirect(redirect) {
  return typeof redirect === "string" && redirect.startsWith("/request/A-5-1/");
}

/**
 * 依頼済み見積の案内（showInfo）後、見積詳細画面へ遷移する
 * @param {Object} result - APIレスポンス
 * @param {{ replace: (url: string) => void }} router - Next.js router
 * @param {{ showInfo?: (message: string, title?: string) => Promise<unknown>, showError?: (message: string) => void }} actions
 * @returns {Promise<boolean>} リダイレクトまたはエラー表示を行った場合 true
 */
export async function handleRequestEntryRedirectResult(result, router, actions) {
  if (result?.result === true && isSubmittedDetailRedirect(result.redirect)) {
    const message = result.notice ?? ALREADY_SUBMITTED_MESSAGE;
    if (actions.showInfo) {
      await actions.showInfo(message);
    }
    router.replace(result.redirect);
    return true;
  }
  if (result?.result === false && result.error) {
    actions.showError?.(result.error);
    return true;
  }
  return false;
}

/** @deprecated handleRequestEntryRedirectResult を使用 */
export const handleRequestEntryInitResult = handleRequestEntryRedirectResult;
